import { Outlet } from "react-router-dom";
import CommonHeader from "../Components/CommonHeader";
import CommonFooter from "../Components/CommonFooter";


const CoursesLayout = () => {
  return (
    <>
      <CommonHeader />
        <Outlet />   
      <CommonFooter />
    </>
  );
};

export default CoursesLayout;
